// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BidContractsTableRowFragmentDoc } from '../../../components/bid-contracts/BidContractsTable.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentContractQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
}>;


export type DevelopmentContractQuery = { __typename?: 'Query', development: { __typename?: 'Development', id: string, name: string, bidContracts: Array<{ __typename?: 'BidContract', id: string, isPrimary?: boolean | null | undefined, isInternalEstimate: boolean, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, latestRevision: { __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], endDate?: Types.Scalars['Date']['input'] | null | undefined, hasOutdatedScope: boolean, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, costCodes: Array<{ __typename?: 'CostCode', id: string, number: string }> } }> } };


export const DevelopmentContractDocument = gql`
    query DevelopmentContract($developmentId: ID!) {
  development(id: $developmentId) {
    id
    name
    bidContracts {
      ...BidContractsTableRow
    }
  }
}
    ${BidContractsTableRowFragmentDoc}`;

/**
 * __useDevelopmentContractQuery__
 *
 * To run a query within a React component, call `useDevelopmentContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentContractQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *   },
 * });
 */
export function useDevelopmentContractQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentContractQuery, DevelopmentContractQueryVariables> & ({ variables: DevelopmentContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentContractQuery, DevelopmentContractQueryVariables>(DevelopmentContractDocument, options);
      }
export function useDevelopmentContractLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentContractQuery, DevelopmentContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentContractQuery, DevelopmentContractQueryVariables>(DevelopmentContractDocument, options);
        }
// @ts-ignore
export function useDevelopmentContractSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentContractQuery, DevelopmentContractQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentContractQuery, DevelopmentContractQueryVariables>;
export function useDevelopmentContractSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentContractQuery, DevelopmentContractQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentContractQuery | undefined, DevelopmentContractQueryVariables>;
export function useDevelopmentContractSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentContractQuery, DevelopmentContractQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentContractQuery, DevelopmentContractQueryVariables>(DevelopmentContractDocument, options);
        }
export type DevelopmentContractQueryHookResult = ReturnType<typeof useDevelopmentContractQuery>;
export type DevelopmentContractLazyQueryHookResult = ReturnType<typeof useDevelopmentContractLazyQuery>;
export type DevelopmentContractSuspenseQueryHookResult = ReturnType<typeof useDevelopmentContractSuspenseQuery>;
export type DevelopmentContractQueryResult = Apollo.QueryResult<DevelopmentContractQuery, DevelopmentContractQueryVariables>;